export const ACCESS_TOKEN_KEY = 'jwt_access_token';
export const REFRESH_TOKEN_KEY = 'jwt_refresh_token';
